<template>
  <div class="hello">
    <h1>{{ msg }}</h1>
    <p class="description">
      For a guide and recipes on how to configure or customize this project,<br />
      check out the
      <a href="https://vuejs.org" target="_blank" rel="noopener"
        >Vue.js documentation</a
      >.
    </p>

    <div class="section">
      <h3>Ecosystem</h3>
      <ul class="link-grid">
        <li>
          <a href="https://app.feegow.com" target="_blank">🌐 Feegow</a>
        </li>
        <li>
          <a href="https://watson.docplanner.design/" target="_blank"
            >🎨 Watson</a
          >
        </li>
        <li>
          <a href="https://vuex.vuejs.org" target="_blank">🧠 Vuex</a>
        </li>
        <li>
          <a
            href="https://github.com/vuejs/vue-devtools#vue-devtools"
            target="_blank"
          >
            🔧 Vue Devtools
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "HelloWorld",
  props: {
    msg: String,
  },
});
</script>

<style scoped lang="scss">
.hello {
  h1 {
    font-size: 24px;
    margin-bottom: 12px;
  }

  .description {
    font-size: 15px;
    color: #666;
    line-height: 1.6;
    margin-bottom: 30px;
  }

  .section {
    text-align: center;
  }

  h3 {
    margin-bottom: 16px;
    font-size: 18px;
  }

  .link-grid {
    list-style: none;
    padding: 0;
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    gap: 16px;
  }

  li a {
    background: #f9f9f9;
    border: 1px solid #e0e0e0;
    padding: 10px 14px;
    border-radius: 8px;
    text-decoration: none;
    color: #2c3e50;
    font-weight: 500;
    transition: all 0.2s ease;
    display: inline-block;
  }

  li a:hover {
    background-color: #eaf7f1;
    color: #42b983;
    border-color: #c6f1dc;
  }
}
</style>
